import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enabledFeatures'
})
export class EnabledFeaturesPipe implements PipeTransform {
    transform(items: Array<any>): Array<any> {
        return items.filter(item => item.isEnabled);
    }
  }

@Pipe({
    name: 'availableProgramOptions'
})
export class AvailableProgramOptionsPipe implements PipeTransform {
  transform(items: Array<any>): Array<any> {
      return items.filter(item => item.isEnabled && item.canJoin);
  }
}

@Pipe({
    name: 'ldcOptions'
})
export class LdcOptionsPipe implements PipeTransform {
  transform(items: Array<any>): Array<any> {
    return items.filter(item => {
      if (!item.isEnabled || item.programOptions.length == 0){
        return false;
      } else{
          var options = item.programOptions.filter(po => po.isEnabled && po.canJoin);
          return options != null && options.length > 0;
      }
    })
  }
}

@Pipe({
    name: 'transactionType'
})
export class TransactionTypePipe implements PipeTransform {
    transform(item: any): any {     
        if (item != null && item.details != null) {
            return item.details;
        }

        return null;
    }
}
